import { render } from "./WorkspaceView.vue?vue&type=template&id=157ccda6"
import script from "./WorkspaceView.vue?vue&type=script&lang=js"
export * from "./WorkspaceView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe-registry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__